<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card v-if="dialog" style="background-color: #f9f9f9 !important;">
      <v-toolbar dark :color="$primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="colheita-titulo">
          {{getSession.Colheita.brigada}}
          <span>{{getSession.Colheita.data}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items></v-toolbar-items>
      </v-toolbar>
      <v-row>
        <Datatable
          v-if="$_HASPERMISSION(NAME, getSession.user.id_tipo_utilizador)"
          :TableItems="TableItems"
          :TableHeaders="TableHeaders"
          :FormFields="FormFields"
          :TableActions="TableActions"
          :ModalNewText="ModalNewText"
          :ModalUpdateText="ModalUpdateText"
          :ModalDeleteText="ModalDeleteText"
          :DeleteDialogTitle="DeleteDialogTitle"
          :TableTitle="TableTitle"
          :Store="Store"
        />
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import { _MODELS } from "@/store/_MAIN"
const _NAME = "UTILIZADOR_COLHEITA"
export default {
  components: {
    Datatable: () => import("@/components/Datatable")
  },
  watch: {
    dialog(val) {
      val || this.close()

      this.$forceUpdate()
    }
  },
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    },
    TableItems() {
      return this.$store.getters[`${this.NAME}/getAll`].map(el => {
        el.utilizador = this.$store.getters["utilizador/getById"](
          el.id_utilizador
        )
        return el
      })
    }
  },
  created() {
    this.$eventBus.$on("ColheitaDialog", state => {
      this.dialog = state
    })
  },
  data: () => ({
    Store: "utilizador_colheita",
    TableTitle: "Lista de utilizadores da colheita",
    ModalNewText: "Adicionar utilizador à colheita",
    ModalUpdateText: "Aletrar colheita",
    DeleteDialogTitle: "Remover utilizador",
    ModalDeleteText: "Pretende apagar remover este utilizador da colheita?",
    TableActions: _MODELS[_NAME]._ACTIONS,
    FormFields: _MODELS[_NAME]._FIELDS,
    TableHeaders: _MODELS[_NAME]._HEADERS,
    NAME: _NAME.toLowerCase(),
    dialog: false
  }),
  methods: {
    close() {
      this.dialog = false

      setTimeout(() => {
        this.$eventBus.$emit("ClearDialog")
      }, 110)
    }
  }
}
</script>
<style scoped>
.colheita-titulo {
  font-size: 25px !important;
}

.colheita-titulo span {
  font-size: 14px !important;
}
</style>
